export default {
    SET_SELECTION: (state, selection) => {
        state.filters.sendTo = selection;
    },
    SET_COUNT: (state, count) => {
        state.count = count;
    },
    SET_DRIVERS: (state, drivers) => {
        state.drivers = drivers;
    },
    CLEAR_ARTICLE: (state) => {
        state.article = {
            title: '',
            body: '',
            shown: true
        };
    },
    UPDATE_ARTICLE: (state, update) => {
        state.article = Object.assign({}, state.article, update);
    },
    SET_PHONES: (state, phones) => {
        state.filters.phones = phones;
    },
    SET_NORMALIZE_PHONES: (state, normalizePhones) => {
        state.normalizePhones = normalizePhones;
    },
    SET_RESULT: (state, result) => {
        state.result = result;
    },
    SET_LOAD(state, isLoaded) {
        state.isLoaded = isLoaded;
    }
};
